
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55mm","height":"336","viewBox":"0 0 55 88.9"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"fg_background",attrs:{"fill":"#fff","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M7.053 7.601v4.91h2.272v-2.454h4.543L9.325 22.333h2.272l4.543-12.276V7.6H9.325zM47.947 81.26v-4.91h-2.272v2.454h-4.543l4.543-12.276h-2.271L38.86 78.804v2.456h6.815z"}})]),_c('g',{staticClass:"fg_background"},[_c('path',{staticClass:"colorable",attrs:{"d":"M19.775 29.699v9.82h4.544v-4.91h9.088l-9.088 24.553h4.544l9.088-24.553V29.7H24.319z","fill-rule":"evenodd"}})])])
          )
        }
      }
    